const { CardDeck, CivilCardTypes } = require("../../Constants/Names/CardTypes");
const Card = require("./Card");

class WonderCard extends Card {
    constructor(name, wonder)
    {
        super(
            CardDeck.Civil,
            CivilCardTypes.Wonder,
            null,
            name,
            wonder.age,
            wonder.text,
            {}
        )
        // Resource cost of each stage, in build order
        this.stageCosts = wonder.stageCosts;
        // What the stages are paid in (International Red Cross: food)
        this.stageCurrency = wonder.payWith ?? 'resources';
        // Fixed bonuses printed along the bottom of the card, and stats it changes by a varying amount (shown as ?)
        this.bonuses = wonder.bonuses ?? {};
        this.varies = wonder.varies ?? [];
        this.image = WonderCard.ImageKey(name);
    }

    // Key of a wonder's picture in the image context: each word capitalized, punctuation dropped
    // ("Library of Alexandria" -> LibraryOfAlexandria, "St. Peter's Basilica" -> StPetersBasilica)
    static ImageKey = (name) => name.replace(/[^A-Za-z ]/g, '').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
}

module.exports = WonderCard;